import axios from 'axios';

const errorCodeList = [900, 903, 904, 910, 924];

/**
 * Util function that determines if any of the following error codes are thrown, 900, 903, 904, 910, 924 
 * read more here. https://docs.finicity.com/aggregation-status-codes/
 * @param {number} errorCode errorCode thrown from the userEvent from FinicityConect
 * @return {boolean}
 */
function shouldRerouteUserToPlaid(errorCode) {
  return errorCodeList.includes(errorCode);
} 

/**
 * Helper function responsible for making a post request to our backend.
 * @param {object} object returned from the userEvent on Finicty connect, 
 * Read more here.
 * https://docs.finicity.com/user-events-2-0-optional/
 * https://docs.finicity.com/route-events-2-0-optional/
 * @param {String} finicityCustomerId finicity customer Id, used to report data on Firebase tables
 * @param {String} userId current primary UID, returned from redux store.
 * @returns {null} 
 */
async function finicityEventReporting(data, finicityCustomerId, userId, type) {
  await axios.post(`/api/v2/accounts/finicityEventReporting`, {type, data: {...data, finicityCustomerId, userId} })
}

export {finicityEventReporting, shouldRerouteUserToPlaid}